import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const PageContainer = (props) => {
  const {
    location,
    currentPage,
    LandingPage,
    SurveyPage,
    SummaryPage,
    DetailsPage,
    render
  } = props;
  const redirect = currentPage !== location.pathname ? <Redirect to={ currentPage } push/> : null;

  return <>
    {
      render({
        route: <Switch location={ location }>
          <Route exact path="/guide" component={ LandingPage }/>
          <Route path="/guide/spa/:uuid/:path/:page" component={ SurveyPage }/>
          <Route path="/guide/:uuid/summary" component={ SummaryPage }/>
          <Route path="/guide/:uuid/details" component={ DetailsPage }/>
        </Switch>,
        props
      })
    }
    { redirect }
  </>;
};

PageContainer.propTypes = {
  location: PropTypes.object,
  currentPage: PropTypes.string,
  LandingPage: PropTypes.object,
  SurveyPage: PropTypes.object,
  SummaryPage: PropTypes.object,
  DetailsPage: PropTypes.object,
  render: PropTypes.func,
};

export default connect( (state) => {
  return {
    currentPage: state.currentPage
  };
})(PageContainer);
